module.exports = __webpack_public_path__ + "img/crypto-bnb.1aa88810.svg";